import { Button, Card, Spinner, Typography } from '@material-tailwind/react';
import React, { useEffect, useState, useMemo } from 'react'
import { useShared } from '../../hooks/useShared';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';
import ASwitch from '../../components/fields/ASwitch';
import APDate from '../../components/fields/APDate';
import ASpinner from '../../components/partials/ASpinner';
import AIcon from '../../components/partials/AIcon';
import UploadFiles from '../../components/upload/UploadFiles';
const fields = [
    {
        label: 'نوعيت مکتوب', name: 'doc_type', type: 'select', roles: [1], icon: 'text-outline', className: '', required: "Please select file time.",
        options: []
    },
    { label: 'شماره', name: 'number', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "Number is required.", },
    { label: 'عنوان', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "Name is required.", },
    { label: 'مرجع', name: 'reference', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "Name is required.", },
    { label: 'تاريخ مکتوب', name: 'from_date', type: 'pdate', roles: [1], icon: 'text-outline', className: '', required: false, },
    { label: 'موقعيت', name: 'physical_location', type: 'textarea', roles: [1], icon: 'text-outline', className: '', required: false, },
    { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },
];

const breadcrumbs = [{ name: 'آرشيف', link: '/archives' }, { name: 'اپلود مکتوب', link: '/new_archive/0' },];

export default function NewArchive() {

    const { http, auth, model, navigate, setProgress, location, setMessage, fetchModelCounts, } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1, 2, 19])) {
            return navigate("/db/notAllowed")
        }
    }, [])

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [files, setFiles] = useState([])
    const [inputFields, setInputFields] = useState([...fields])
    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({
        defaultValues: useMemo(() => {
            return location?.state?.model;
        }, [model])
    });

    useEffect(() => {
        const fls = location?.state?.model?.attachments;
        if (fls)
            setFiles(fls)
    }, [model])


    useEffect(() => {
        if (inputFields[0]?.options?.length === 0)
            http.post(`/api/categoryAdvanceSearch?typeId=7`).then(res => {
                console.log('get archive ', res);
                if (res.data.success) {
                    inputFields[0].options = res.data.data
                    setInputFields([...inputFields])
                }
            })

    }, [inputFields[0]?.options])


    const mReset = () => {
        reset({})
    }


    const submit = async (sData) => {

        setErrorMessage(null)
        let formData = new FormData();
        if (sData?.id){
            formData.append('id', sData.id)
            if (sData?.type_number) formData.append('type_number', sData.type_number);
        };

        formData.append('name', sData.name);
        formData.append('doc_type', JSON.stringify(sData.doc_type));
        formData.append('from_date', sData.from_date ? sData.from_date : '');
        // formData.append('to_date', sData.to_date);
        formData.append('number', sData.number);
        formData.append('reference', sData.reference);
        formData.append('physical_location', sData.physical_location);
        formData.append('status', sData.status ? 1 : 0);
        formData.append('description', sData.description);
        formData.append('TotalFiles', files.length);
        files.map((f, i) => {
            formData.append('files' + i, f.file)
            if (f.id) formData.append('aId' + i, f.id);
        })

        try {
            setLoading(true)
            const res = await http.upload(`api/archives`, formData, event => {
                setProgress(Math.round(event.progress * 100));
            });

            console.log('model  ', res);

            if (res.data?.success) {
                setLoading(false)
                toast.success(res.data.message);
                setMessage(res.data.message)
                fetchModelCounts()
                navigate(-1)
            }
        } catch (error) {
            console.log(error);
            setLoading(false)
            const err = error?.response?.data

            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }
        return false
    }



    return (
        <>
            <ABreadcrumbs links={breadcrumbs} />

            <div className='md:grid gap-4 md:grid-cols-2'>

                <Card className="w-full   p-2 md:p-4 mt-4 relative">

                    <p className="text-sm text-main-color font-bold capitalize">اپلود قايل جديد</p>
                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        {loading && <ASpinner />}
                        {inputFields[0]?.options?.length > 0 ? <div className=" grid  gap-3 items-baseline md:grid-col-2">


                            {inputFields?.map((data, i) => {

                                return (<React.Fragment key={i}>{
                                    data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                        <AInput v={{ register, errors, data }} />
                                        : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }} />
                                            : data?.type === 'pdate' ? <APDate v={{ register, errors, control, data, setValue }} />
                                                : data?.type === 'switch' ? <ASwitch v={{ register, errors, data }} />
                                                    : null
                                }</React.Fragment>)
                            })}


                        </div> : <ASpinner />}
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-start'>
                            <Button className="btn1 w-full md:w-[10%] amiriB text-white text-base" size='sm' type="submit" disabled={loading || files?.length === 0}>  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>
                            <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                        </div>
                    </form>

                </Card>

                <UploadFiles v={{ files, setFiles, className: "" }} />

            </div>
            <ToastContainer />
        </>
    )
}
